import * as React from "react";
import {
  Avatar,
  Box,
  Card,
  CardContent,
  CardMedia,
  Stack,
} from "@mui/material";
import imag from "../assets/imgs/image_0002.jpg";
import profile from "../assets/profilePics/pp_image_0001.jpg";

const CustomCard = ({ img }) => {
  const cardProps = {
    style: {
      height: "300px",
      width: "200px",
      objectFit: "cover",
      borderRadius: "1em",
    },
  };

  const imgProps = {
    style: {
      height: "100%",
    },
  };

  function importAll(r) {
    let images = {};
    r.keys().map((item, index) => {
      images[item.replace("./", "")] = r(item);
    });
    // console.log(images);
    return images;
  }

  const images = importAll(
    require.context("../assets/imgs", false, /\.(png|jpe?g|svg)$/)
  );

  React.useEffect(() => {
    Object.keys(images).map((item, i) => {
      console.log(images[item]);
    });
  }, []);

  return (
    <Box
      sx={{
        display: "flex",
        overflowX: "auto",
      }}
    >
      <Stack direction="row" spacing={5}>
        {Object.keys(images).map((item, i) => (
          <Card {...cardProps} key={i}>
            <img src={images[item]} {...imgProps} />
            <CardContent
              style={{ zIndex: 10, position: "relative", bottom: "5.5em" }}
            >
              <Stack>
                <Avatar
                  src={profile}
                  style={{ height: "2.5em", width: "2.5em" }}
                />
              </Stack>
            </CardContent>
          </Card>
        ))}
      </Stack>
    </Box>
  );
};

export default CustomCard;
